import {Result} from './Result'
import {HttpError} from './Http'

export type WebData<T> = Loading | Failure | Success<T>

export interface Loading {
    type: 'Loading'
}

export interface Failure {
    type: 'Failure'
    error: HttpError
}

export interface Success<T> {
    type: 'Success'
    value: T
}

export function fromResult<T>(result: Result<HttpError, T>): WebData<T> {
    switch (result.type) {
        case 'Ok':
            return {
                type: 'Success',
                value: result.value,
            }
        case 'Err':
            return {
                type: 'Failure',
                error: result.error,
            }
    }
}

export function map<A, B>(fn: (value: A) => B, webData: WebData<A>): WebData<B> {
    switch (webData.type) {
        case 'Success':
            return {
                type: 'Success',
                value: fn(webData.value),
            }
        default:
            return webData
    }
}

export function toNullable<T>(webData: WebData<T>): T | null {
    return webData.type === 'Success' ? webData.value : null
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/WebData.ts